(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("3d-tiles-simple-viewer", [], factory);
	else if(typeof exports === 'object')
		exports["3d-tiles-simple-viewer"] = factory();
	else
		root["3d-tiles-simple-viewer"] = factory();
})(self, function() {
return 